export { default as logo } from './logo.png';
export { default as logout } from './logout.svg';
export { default as miroPalette } from './miro-palette.svg';
export { default as spinner } from './spinner.gif';
export { default as userPlaceholder } from './user-placeholder.jpg';
